/* ===================================== */
/* SHARE BUTTON */
/* ===================================== */

document.addEventListener('click', function (e) {
  const btn = e.target.closest('.share-button');
  if (!btn) return;

  const data = { title: document.title, url: location.href };

  if (navigator.share) {
    navigator.share(data).catch(() => {});
  } else if (navigator.clipboard) {
    navigator.clipboard.writeText(location.href).then(() => {
      alert('Link copiado!');
    });
  }
});


/* ===================================== */
/* GLOBAL SHOPIFY DIALOG SCROLL FIX */
/* ===================================== */

(function () {

  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  if (!isTouch) return;

  const DIALOG_SELECTOR = 'dialog[scroll-lock]';

  function restoreScroll() {

    const y = parseInt(document.body.dataset.scrollY || 0, 10);

    document.documentElement.style.overflow =
    document.body.style.overflow =
    document.body.style.position =
    document.body.style.top = '';

    document.body.classList.remove(
      'overflow-hidden',
      'modal-open',
      'js-modal-open'
    );

    if (y) {
      window.scrollTo(0, y);
      delete document.body.dataset.scrollY;
    }
  }

  function getOpenDialog() {
    return document.querySelector(`${DIALOG_SELECTOR}[open]`);
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (dialog.hasAttribute('open')) dialog.close();
    restoreScroll();
  }

  /* Intercepta fechamento normal */
  document.addEventListener('close', function (e) {
    if (e.target.matches(DIALOG_SELECTOR)) {
      restoreScroll();
    }
  }, true);

  /* Observer único */
  const observer = new MutationObserver(() => {
    if (!getOpenDialog()) restoreScroll();
  });

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  /* Gesture back mobile */
  window.addEventListener('popstate', function () {
    const dialog = getOpenDialog();
    if (!dialog) return;
    closeDialog(dialog);
  });

})();



/* ===================================== */
/* MEGA MENU DELAY SUAVE – DESKTOP ONLY */
/* ===================================== */

document.addEventListener("DOMContentLoaded", function () {

  if (window.innerWidth < 990) return;

  const headerMenu = document.querySelector("header-menu");
  if (!headerMenu) return;

  let closeTimer = null;
  const delayTime = 250; // 🔥 mais curto agora

  const items = headerMenu.querySelectorAll(".menu-list__list-item");

  items.forEach(item => {

    const submenu = item.querySelector(".menu-list__submenu");
    if (!submenu) return;

    item.addEventListener("pointerenter", () => {
      clearTimeout(closeTimer);
    });

    item.addEventListener("pointerleave", () => {
      clearTimeout(closeTimer);

      closeTimer = setTimeout(() => {
        // 🔥 Apenas dispara o evento original do tema
        const event = new Event("pointerleave", { bubbles: true });
        item.dispatchEvent(event);
      }, delayTime);
    });

    submenu.addEventListener("pointerenter", () => {
      clearTimeout(closeTimer);
    });

  });

});



// (function() {
//   const textoOriginal = "Interesting? Click '' to save it to your Meus Favoritos.";
//   const textoTraduzido = "Gostou? Clique para salvar nos seus favoritos.";

//   function traduzirTexto(node) {
//     if (node.nodeType === 3) { // texto puro
//       if (node.nodeValue.includes(textoOriginal)) {
//         node.nodeValue = node.nodeValue.replace(textoOriginal, textoTraduzido);
//       }
//     } else {
//       node.childNodes.forEach(traduzirTexto);
//     }
//   }

//   // roda uma vez ao carregar
//   traduzirTexto(document.body);

//   // observa mudanças no DOM (Shopify / apps dinâmicos)
//   const observer = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//       mutation.addedNodes.forEach((node) => {
//         traduzirTexto(node);
//       });
//     });
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// })();